import { render } from "./PortfolioModal.vue?vue&type=template&id=0a19d5b8&scoped=true"
import script from "./PortfolioModal.vue?vue&type=script&lang=js"
export * from "./PortfolioModal.vue?vue&type=script&lang=js"

import "./PortfolioModal.vue?vue&type=style&index=0&id=0a19d5b8&scoped=true&lang=css"

import exportComponent from "/home/circleci/project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a19d5b8"]])

export default __exports__